module.exports = __webpack_public_path__ + "img/1557614090221854722.7146267d.png";